<template>
  <div class="floating-links" :class="{ 'collapsed': isCollapsed }">
    <div class="toggle-btn" @click="toggleWindow">
      <i class="toggle-arrow" :class="isCollapsed ? 'arrow-left' : 'arrow-right'"></i>
    </div>

    <transition name="slide-right">
      <div v-if="!isCollapsed" class="links-panel">

        <div class="panel-section">
          <div class="panel-header">快捷链接</div>
          <div class="links-list">
            <a href="https://mail.cstnet.cn/" target="_blank" rel="noopener noreferrer" class="link-item">
              <span>📧</span> 邮箱
            </a>
            <a href="https://pan.cstcloud.cn/" target="_blank" rel="noopener noreferrer" class="link-item">
              <span>☁</span> 科技云盘
            </a>
            <a href="/#/serviceDetail?id=573" target="_blank" rel="noopener noreferrer" class="link-item">
              <span>🖥</span> 科技云会（腾讯版）
            </a>
            <a href="https://www1.cstcloud.cn/#servicelist_section" target="_blank" rel="noopener noreferrer" class="link-item">
              <span>📋</span> 认证服务列表
            </a>
            <a href="https://www1.cstcloud.cn/#resrecom_section" target="_blank" rel="noopener noreferrer" class="link-item">
              <span>📚</span> 学科资源
            </a>
          </div>
        </div>

        <div class="panel-divider"></div>

        <div class="panel-section">
          <div class="bottom-links">
            <a href="https://www1.cstcloud.cn/" target="_blank" rel="noopener noreferrer" class="bottom-link">回到旧版</a>
            <span class="bottom-sep">|</span>
            <a href="https://www.cstcloud.net/" target="_blank" rel="noopener noreferrer" class="bottom-link">English</a>
          </div>
        </div>

      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const isCollapsed = ref(false)

const toggleWindow = () => {
  isCollapsed.value = !isCollapsed.value
}
</script>

<style scoped>
.floating-links {
  position: fixed;
  top: 105px;
  right: 0;
  z-index: 1000;
  display: flex;
  align-items: flex-start;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.toggle-btn {
  width: 20px;
  height: 60px;
  margin-top: 4px;
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
  border-radius: 15px 0 0 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: white;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  user-select: none;
}

.toggle-btn:hover {
  background: linear-gradient(135deg, #7c3aed 0%, #4f46e5 100%);
  transform: scale(1.05);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
}

.toggle-arrow {
  width: 0;
  height: 0;
  transition: all 0.3s ease;
}

.toggle-arrow.arrow-right {
  border-left: 6px solid white;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
}

.toggle-arrow.arrow-left {
  border-right: 6px solid white;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
}

.links-panel {
  width: 180px;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(12px);
  border-radius: 12px 0 0 12px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
  overflow: hidden;
}

.panel-header {
  padding: 12px 16px 8px;
  font-size: 13px;
  font-weight: 600;
  color: #4f46e5;
  border-bottom: 1px solid #f0eeff;
  letter-spacing: 0.5px;
}

.links-list {
  padding: 6px 0;
}

.link-item {
  display: flex;
  align-items: center;
  padding: 9px 16px;
  font-size: 13px;
  font-weight: 600;
  color: #555;
  text-decoration: none;
  transition: all 0.2s ease;
  gap: 8px;
  line-height: 1.4;
}

.link-item:hover {
  background: #f5f3ff;
  color: #4f46e5;
}


.link-item.link-highlight:hover {
  background: linear-gradient(135deg, #ede9fe, #f5f3ff);
}

.collapsed .toggle-btn {
  border-radius: 15px;
}

/* 过渡动画 */
.slide-right-enter-active {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-right-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-right-enter-from,
.slide-right-leave-to {
  transform: translateX(100%) scale(0.8);
  opacity: 0;
}

.panel-divider {
  height: 1px;
  background: #f0eeff;
  margin: 0 12px;
}

.bottom-links {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  gap: 8px;
}

.bottom-link {
  font-size: 12px;
  color: #666;
  text-decoration: none;
  transition: color 0.2s ease;
}

.bottom-link:hover {
  color: #4f46e5;
}

.bottom-sep {
  color: #ddd;
  font-size: 12px;
}

@media (max-width: 768px) {
  .floating-links {
    top: 100px;
  }

  .links-panel {
    width: 160px;
  }

  .toggle-btn {
    width: 15px;
    height: 40px;
  }

  .link-item {
    padding: 7px 12px;
    font-size: 12px;
  }
  .floating-links {
    display: none;
  }
}
</style>
